<template>
  <div id="tablePage">
    <!-- 持仓汇总 -->
    <div class="orderTable">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        :cell-class-name="directionClass"
        @sort-change="sortChange"
        v-loading="loading"
      >
        <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <el-table-column
          prop="commodityCode"
          label="商品代码"
        >
        </el-table-column>
        <el-table-column
          prop="commodityName"
          label="商品名称"
        >
        </el-table-column>
        <el-table-column
          prop="bsFlag"
          label="买|卖"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          prop="initAvgPrice"
          label="订立均价"
          sortable="custom"
        >
          <template slot-scope="scope">
            <!--  :class="scope.row.bsFlag=='买入'?'red-row':'green-row'" -->
            <span> {{ scope.row.initAvgPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="quantity"
          label="存货数量"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.quantity }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="scQuantity"
          label="锁仓数量"
          min-width="110"
        >
          <template slot-scope="scope">
            <span class="yellow-row  fr"> {{ scope.row.optimizeQuantity }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="frozeQuantity"
          label="委托冻结数量"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.frozeQuantity }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="ddQuantity"
          label="抵顶数量"
          min-width="100"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.ddQuantity }}</span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="ddQuantity"
          label="抵顶冻结数量"
          min-width="120"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.ddQuantity }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="totalPrice"
          label="存货金额"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.totalPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="holdMargin"
          label="订货金额"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.holdMargin }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="holdPl"
          label="货值变化"
        >
          <template slot-scope="scope">
            <span :class="scope.row.textColor"> {{ scope.row.holdPl }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="currentHoldPl"
          label="实时货值变化"
        >
          <template slot-scope="scope">
            <span :class="scope.row.textSColor"> {{ scope.row.currentHoldPl }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="date"
          label="实时货值变化"
        >
        </el-table-column> -->
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
/*global http protocol util*/
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      tableHeight: 0,
      loading: false,
      tableData: [],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      timer: null,
      oOrderPrice: '',
      thsTableWidth: {
        action: 142
      },
      HoldFrontSum: {
        'avgPrice': 0,
        'bsFlag': '',
        'commodityCode': '',
        'commodityId': 0,
        'commodityName': '',
        'createTime': 0,
        'firmId': 0,
        'floatPl': 0,
        'holdId': 0,
        'holdMargin': 0,
        'quantity': 0,
        'totalPrice': 0,
        'frozeQuantity': 0,
        'ddQuantity': 0,
        'tqTransferQuantity': 0,
        'transferQuantity': 0,
        'unitNumeral': 0,
        'updateTime': 0
      },
      dataArr: '',
      // dialog
      zrTitle: '转让',
      dialogFormVisible: false,
      transfer: {
        price: '',
        quantity: ''
      },
      // 订单数据
      oOrderData: {
        takeProfitPointPriceShow: '',
        stopLossPointPriceShow: ''
      }, dialogVisible: false,
      isNetWrong: false
    }
  },
  computed: {
    ...mapGetters(['h_holdTime', 'sessionInfoGetter', 'marketDetails', 'commodityStrategyGetter', 'h_sumClosePl', 'marketStatusGetter', 'marketStatusInNewTopline'])
  },
  watch: {
    h_holdTime() {
      this.showData()
    },
    marketDetails: {
      handler(val, oldVal) {
        this.showData()
      },
      deep: true
    }
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },

  mounted() {
    this.showData()
    // this.timer = setInterval(() => {
    //   this.showData()
    // }, window.g.APP_RUNLOOP_TIME ? window.g.APP_RUNLOOP_TIME : 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      this.loading = true
      protocol.queryUserPositionSummariesNew.data.page =
          this.pageData.currentPage - 1
      protocol.queryUserPositionSummariesNew.data.size =
          '' + this.pageData.pageSize
      protocol.queryUserPositionSummariesNew.data.firmId = this.sessionInfoGetter.firmId
      protocol.queryUserPositionSummariesNew.data.commodityId = null
      http.gPost(protocol.queryUserPositionSummariesNew).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.dataArr = JSON.stringify(response.data.value.content)
            this.judgeDataType(arr)
            this.HoldFrontSum = response.data.value.sumData
          }
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
        setTimeout(() => {
          that.showData()
        }, 1000)
      })
    },
    threeTxtColor(price) {
      // 商品价格大于0红色，小于0绿色，等于0灰色
      if (!isNaN(price)) {
        if (price > 0) {
          return 'red-row'
        } else if (price < 0) {
          return 'green-row'
        } else {
          return ''
        }
      }
      return ''
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        arrIndex.floatPL = 0
        arrIndex.floatSsPL = 0
        arrIndex.textColor = ''
        arrIndex.textSColor = ''
        arrIndex.priceColor = ''
        that.marketDetails.forEach(value => {
          if (value.symbolId == arrIndex.commodityId) {
            var MarketPrice = value.averagePrice.toFixed(that.coinSmallDigital(value).coinDigitalNum)
            if (that.marketStatusGetter.status === 'E' || that.marketStatusGetter.status === 'C') {
              arrIndex.currentHoldPl = arrIndex.hholdPl.toFixed(that.coinSmallDigital(value).coinDigitalNum)
            } else {
              // // avgPrice: 明细均价
              // arrIndex.currentHoldPl = arrIndex.bsFlag === 'B'
              //   ? (util.floatSub(value.close, arrIndex.avgPrice) * arrIndex.quantity * value.unitNumeral + arrIndex.hholdPl).toFixed(that.coinSmallDigital(value).coinDigitalNum)
              //   : (util.floatSub(arrIndex.avgPrice, value.close) * arrIndex.quantity * value.unitNumeral + arrIndex.hholdPl).toFixed(that.coinSmallDigital(value).coinDigitalNum)
              // totalPrice 总价
              arrIndex.currentHoldPl = arrIndex.bsFlag === 'B'
                ? (util.floatSub(value.close * arrIndex.quantity, arrIndex.totalPrice) * value.unitNumeral + arrIndex.hholdPl).toFixed(that.coinSmallDigital(value).coinDigitalNum)
                : (util.floatSub(arrIndex.totalPrice, value.close * arrIndex.quantity) * value.unitNumeral + arrIndex.hholdPl).toFixed(that.coinSmallDigital(value).coinDigitalNum)
            }
            MarketPrice = MarketPrice == 0 ? value.close.toFixed(that.coinSmallDigital(value).coinDigitalNum) : MarketPrice // 行情均价
            arrIndex.holdPl = arrIndex.bsFlag === 'B'
              ? (util.floatSub(MarketPrice, arrIndex.initAvgPrice) * arrIndex.quantity * value.unitNumeral).toFixed(that.coinSmallDigital(value).coinDigitalNum)
              : (util.floatSub(arrIndex.initAvgPrice, MarketPrice) * arrIndex.quantity * value.unitNumeral).toFixed(that.coinSmallDigital(value).coinDigitalNum)
            return
          }
        })
        arrIndex.textColor = that.threeTxtColor(Number(arrIndex.holdPl))
        arrIndex.textSColor = that.threeTxtColor(Number(arrIndex.currentHoldPl))
        // 判断时间
        that.modifyTime(arrIndex, 'createTime')
        // 判断方向
        that.modifyData(arrIndex, 'bsFlag', 'B', '买入', '卖出')
        that.modifyData(arrIndex, 'ocFlag', 'O', '订立', '转让')
        // 判断委托状态 1-已委托，2-已成交，3-已撤单，4-部分成交，5-部分成交后撤单
        const stateList = ['已委托', '已成交', '已撤单', '部分成交', '部分成交后撤单']
        stateList.forEach((item, index) => {
          that.modifyData(arrIndex, 'orderStatus', index + 1, item)
        })
      })
      this.tableData = arr
    },
    coinSmallDigital(s) {
      const minPriceChange = s.minPriceChange // 最小数量变动单位
      const minAmountChange = s.minAmountChange // 价格价格变动单位
      let pricePoint = -Math.round(Math.log(minPriceChange) / Math.log(10))
      let amountPoint = -Math.round(Math.log(minAmountChange) / Math.log(10))
      if (pricePoint <= 0) {
        pricePoint = 0
      }
      if (amountPoint <= 0) {
        amountPoint = 0
      }
      return {
        // //symbolId: this.item.symbolId,
        // numStr:/^(\d+)\.(\d{0,6}).*$/,
        numStr: new RegExp('^(\\d+)\\.(\\d{0,' + pricePoint + '}).*$'),
        coinDigitalNum: pricePoint,
        quantityNum: amountPoint, // 数量
        quantityStr: new RegExp('^(\\d+)\\.(\\d{0,' + amountPoint + '}).*$') // 数量
      }
    },
    // 排序
    sortChange(column, prop, order) {
      if (column.order == 'ascending') {
        protocol.queryUserPositionSummariesNew.data.sort[0].direction = 'ASC'
        this.eachSortChange(column.column.property)
      } else if (column.order == 'descending') {
        protocol.queryUserPositionSummariesNew.data.sort[0].direction = 'DESC'
        this.eachSortChange(column.column.property)
      } else {
        protocol.queryUserPositionSummariesNew.data.sort = [{
          direction: 'DESC',
          property: 'holdId'
        }]
      }
      protocol.queryUserPositionSummariesNew.data.firmId = this.sessionInfoGetter.firmId
      // protocol.queryUserPositionSummariesNew.data.bsFlag = this.search.bsFlag == 'A' ? null : this.search.bsFlag
      protocol.queryUserPositionSummariesNew.data.commodityId = null
      if (column.column) {
        http.gPost(protocol.queryUserPositionSummariesNew).then(response => {
          if (response.data.code != 0) {
            this.$message({ message: response.data.message })
            this.isNetWrong = true
          } else {
            this.isNetWrong = false
          }
          if (response.data) {
            if (response.data && response.data.code == '0') {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.HoldFrontSum = response.data.value.sumData
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      return (protocol.queryUserPositionSummariesNew.data.sort[0].property = str)
    },
    // 单元格颜色
    directionClass(row, column, rowIndex, columnIndex) {
      // 根据字段改变样式
      switch (row.columnIndex) {
        // eslint-disable-next-line no-lone-blocks
        case 2: {
          return this.setStrClass(row.row.bsFlag, '卖出', 'dropColor', 'increaseColor')
        }
        default:
          break
      }
    },
    // 合计
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const that = this
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 1) {
          sums[index] = '共' + that.pageData.total + '条'
          return
        }

        if (index === 6) { // 委托冻结数量
          sums[index] = that.HoldFrontSum.frozeQuantity
          return
        }
        if (index === 7) { // 抵顶数量
          sums[index] = that.HoldFrontSum.ddQuantity
          return
        }
        if (index === 8) { // 抵顶冻结数量
          sums[index] = that.HoldFrontSum.ddQuantity
          return
        }
        if (index === 9) { // 存货金额
          sums[index] = that.HoldFrontSum.totalPrice
          return
        }
        if (index === 10) { // 订货金额
          sums[index] = that.HoldFrontSum.holdMargin
          return
        }
        if (index === 11) { // 货值变化
          sums[index] = that.h_sumClosePl // that.HoldDetailListSum.sumClosePl
          // if (that.marketStatusGetter.status == 'P' || that.marketStatusGetter.status == 'T') {
          //   if (protocol.queryUserPositionSummariesNew.data.bsFlag) {
          //     sums[index] = '--'
          //   } else {
          //     sums[index] = that.h_sumClosePl // that.HoldDetailListSum.sumClosePl
          //   }
          // } else {
          //   sums[index] = 0 // that.HoldFrontSum.floatPl
          // }
          return
        }

        sums[index] = ''
      })
      return sums
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale = localStorage.lang || navigator.language.slice(-2).toLowerCase()
      switch (localStorage.lang) {
        case 'en': {
          const tcdTableEnWidth = {
            bsFlag: 120,
            ocFlag: 150,
            closePl: 150
          }
          localStorage.setItem('tcdTableEnWidth', JSON.stringify(tcdTableEnWidth))
          this.tcdTableWidth = JSON.parse(localStorage.tcdTableEnWidth)
        }
          break
        default:
          break
      }
    }

  }

}
</script>